<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-beat" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>

<!-- Page Wrapper -->
<div id="wrapper">
  <app-sidebar></app-sidebar>

  <!-- End of Sidebar -->

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">

    <!-- Main Content -->
    <div id="content">

      <!-- Topbar -->
      <app-header></app-header>
      <!-- End of Topbar -->

      <!-- Begin Page Content -->

      <!-- Begin Page Content -->
      <div class="container-fluid">


        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">Category List</h1>
          <a href="javascript:void(0);" class="d-sm-inline-block btn btn-sm btn-primary shadow-sm" (click)="addCategory()"><i class="fas fa-plus fa-sm text-white-50"></i> Add Category</a>
        </div>


        <!-- DataTales Example -->
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h4 class="m-0 font-weight-bold text-primary">Category List</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">


              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Sr#</th>
                    <th>Name</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of categoryList; let i=index;">
                    <td>{{i+1}}</td>
                    <td>{{item.payload.doc.data().name}}</td>
                    <td align="center">
                      <a href="javascript:void(0);" class="text-primary" (click)="editCategory(item.payload.doc.id, item.payload.doc.data().name)"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="javascript:void(0);" class="text-danger" (click)="deleteCategory(item.payload.doc.id)"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  
                </tbody>
              </table>




            </div>
          </div>

        </div>



      </div>
      <!-- /.container-fluid -->

      <!-- /.container-fluid -->




    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- End of Footer -->

  </div>
  <!-- End of Content Wrapper -->

</div>
<!-- End of Page Wrapper -->

<!-- Scroll to Top Button-->
<a class="scroll-to-top rounded" href="#page-top">
  <i class="fas fa-angle-up"></i>
</a>
  
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">DELETE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Do you want to delete this?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">NO</button>
        <a href="#delete"><button type="button" class="btn btn-primary">YES</button></a>
      </div>
    </div>
  </div>
</div>
  